import React from 'react'
import Whywe from './Whywe'
import HomeWhatWeAre from './HomeWhatWeAre'
import HomeMainSection from './HomeMainSection'
import Industries from './Industries'
import ExploreKapil from './ExploreKapil'
import { useEffect,useState } from 'react'
import ITConsultingSection from './ITConsultingSection'
const HomePage = () => {

  
  return (
    <div>
    
     <section className='bg-[white]'>
        <HomeMainSection/>
      </section>

     <section className=" mt-10">
      <HomeWhatWeAre/>
      </section>
      
      <section>
       <Industries/>
      </section>
      
      <section>
        <Whywe/>
      </section>
    
      <section>
        <ITConsultingSection />
      </section>

      <section>
        < ExploreKapil/>
      </section>
      

    


    </div>
  )
}

export default HomePage
